module.exports = __webpack_public_path__ + "static/img/6.664cac23.png";